import { PlantlifeSharedCardData } from './plantlife-shared-card-data';

export class PlantlifeCardData extends PlantlifeSharedCardData {
  constructor() {
    super();
  }
}
